import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import Section from '../Inputs/Section'
import { Divider, Form, Grid, Header } from 'semantic-ui-react'
import Select from '../Inputs/Select'
import { Conform, ConformAdequat, ConformYes, FromTo, Years, YesNo, YesNoCom } from '../../../utils/FormSelectHelper'
import Input from '../Inputs/Input'
import Checkbox from '../Inputs/Checkbox'
import { autorun, runInAction } from 'mobx'
import Duplicate from '../Inputs/Duplicate'
import { observer } from 'mobx-react'

@observer
class RIGSAR000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry)
  }

  componentDidMount () {
    const { equipment } = this.props

    this.autorun = autorun(() => {
      const residuelle = parseInt(equipment.getValue('residuelle', false, 0))
      const statique = parseInt(equipment.getValue('statique', false, 0))
      if (statique > 0) {
        runInAction(() => {
          equipment.updateValue('differentiel', ((residuelle * 100) / statique).toFixed(2))
        })
      }
    })
  }

  componentWillUnmount () {
    this.autorun()
  }

  /**
   * If 1.19 === na then update more fields
   * @param name
   * @param value
   */
  handleOvertureRapide = (name, value) => {
    const { equipment } = this.props
    if (value === 'na') {
      equipment.updateValue('overRapidMarque', 'na') // 1.19.1
      equipment.updateValue('overRapidModele', 'N/a', true) // 1.19.2
      equipment.updateValue('overRapidNumSerie', 'N/a', true) // 1.19.3
      equipment.updateValue('dispositifAntiNoyade', 'na', true) // 1.20
      equipment.updateValue('interrupteurPressionMarque', 'na') // 1.20.1
      equipment.updateValue('interrupteurPressionModele', 'N/a', true) // 1.20.2
      equipment.updateValue('pressionAirDor', 'na', true) // 2.5.2
      equipment.updateValue('pressionAirDor2', 'N/a', true) // 2.7.3
    }
  }

  /**
   * If 1.20 === na then update more fields
   * @param name
   * @param value
   */
  handleDispositifAntiNoyade = (name, value) => {
    const { equipment } = this.props
    if (value === 'na') {
      equipment.updateValue('interrupteurPressionMarque', 'na') // 1.20.1
      equipment.updateValue('interrupteurPressionModele', 'N/a', true) // 1.20.2
    }
  }

  render () {
    const { equipment } = this.props

    return (
      <>
        <Form>
          <Section title={(<Header as='h2'>1. IDENTIFICATION DE L'ÉQUIPEMENT</Header>)} name='1naCheckbox' equipment={equipment}>
            <Form.Group widths='equal'>
              <Select name='batimentMemeVocation' formEntry={equipment} options={YesNo()} isFixed label='1.1 Bâtiment a-t-il la même vocation' />
              <Select name='plaqueSignaletique' formEntry={equipment} options={Conform()} isFixed label='1.10 Plaque signalétique' />
              <Select name='ouvertureRapide' formEntry={equipment} options={YesNo()} onAfterChanged={this.handleOvertureRapide} label="1.19 Dispositif d'ouverture rapide" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='localisation' formEntry={equipment} isRequired label='1.2 Localisation' />
              <Select name='panneauInfoGeneral' formEntry={equipment} options={Conform()} isFixed label="1.11 Panneau d'information général" />
              <Select
                name='overRapidMarque' className='second-title' formEntry={equipment} options={[
                  { value: 'viking', text: 'Viking' },
                  { value: 'tyco', text: 'Tyco' },
                  { value: 'grinnell', text: 'Grinnell' },
                  { value: 'victaulic', text: 'Victaulic' },
                  { value: 'Hodgman', text: 'Hodgman' },
                  { value: 'Star', text: 'Star' }
                ]} isRequired label='1.19.1 Marque'
              />

            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='numSysteme' formEntry={equipment} isRequired label='1.3 Numéro du système' />
              <Select name='idenTuyauterie' formEntry={equipment} isFixed options={Conform()} label='1.12 Identification de la tuyauterie' />
              <Input name='overRapidModele' className='second-title' formEntry={equipment} isRequired label='1.19.2 Modèle' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='zoneProtege' formEntry={equipment} isRequired label='1.4 Zone protégé' />
              <Select name='idenComposantes' formEntry={equipment} options={Conform()} isFixed label='1.13 Identification des composantes' />
              <Input name='overRapidNumSerie' className='second-title' formEntry={equipment} isRequired label='1.19.3 No de série' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select
                name='marque' formEntry={equipment} options={[
                  { value: 'Viking', text: 'Viking' },
                  { value: 'Tyco', text: 'Tyco' },
                  { value: 'Grinnell', text: 'Grinnell' },
                  { value: 'Gem', text: 'Gem' },
                  { value: 'Reliable', text: 'Reliable' },
                  { value: 'Victaulic', text: 'Victaulic' },
                  { value: 'Astra', text: 'Astra' }
                ]} isRequired label='1.5 Marque'
              />
              <Select name='robinetControle' formEntry={equipment} options={FromTo(1, 50)} isFixed label='1.14 Robinet de contrôle (Qté)' />
              <Select name='dispositifAntiNoyade' formEntry={equipment} options={YesNo()} onAfterChanged={this.handleDispositifAntiNoyade} isRequired label='1.20 Dispositif anti-noyade' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='modele' formEntry={equipment} isRequired label='1.6 Modèle' />
              <Select name='surveillanceRobinet' formEntry={equipment} options={Conform()} isFixed label='1.15 Surveillance des robinets' />
              <Select
                name='interrupteurPressionMarque' className='second-title' formEntry={equipment} options={[
                  { value: 'viking', text: 'Viking' },
                  { value: 'tyco', text: 'Tyco' },
                  { value: 'grinnell', text: 'Grinnell' },
                  { value: 'Victaulic', text: 'Victaulic' },
                  { value: 'integre', text: 'Intégré' },
                  { value: 'autres', text: 'Autres' }
                ]} isRequired label='1.20.1 Marque'
              />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='numSerie' formEntry={equipment} isRequired label='1.7 No de série' />
              <Select
                name='typeInterrupteurAlarm' formEntry={equipment} options={[
                  { value: 'ps101', text: 'PS-10-1' },
                  { value: 'eps101', text: 'EPS10-1' },
                  { value: 'ps102', text: 'PS10-2' },
                  { value: 'eps102', text: 'EPS10-2' },
                  { value: 'other', text: 'Autres' }
                ]} isRequired label="1.16 Type d'interrupteur d'alarme"
              />
              <Input name='interrupteurPressionModele' className='second-title' formEntry={equipment} isRequired label='1.20.2 Modèle' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='annee' formEntry={equipment} options={Years()} isRequired label='1.8 Année' />
              <Select
                name='interrupteurPression2' formEntry={equipment} options={[
                  { value: 'ps401', text: 'PS40-1' },
                  { value: 'ps402', text: 'PS40-2' },
                  { value: 'esp1201', text: 'ESP120-1' },
                  { value: 'esp1202', text: 'ESP120-2' },
                  { value: 'other', text: 'Autres' }
                ]} isRequired label='1.17 Interrupteur haute et basse pression'
              />
              <Select name='nbPointBas' formEntry={equipment} isRequired options={FromTo(0, 30)} label='1.21 Nombre de points bas' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select
                name='diametre' formEntry={equipment} options={[
                  { value: '2', text: '2' },
                  { value: '2.5', text: '2.5' },
                  { value: '3', text: '3' },
                  { value: '4', text: '4' },
                  { value: '6', text: '6' },
                  { value: '8', text: '8' }
                ]} isRequired label='1.9 Diamètre (po)'
              />
              <Input name='empalcementRobinetEssai' formEntry={equipment} isRequired label="1.18 Emplacement du robinet d'essai" />
              <div className='field' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>2. VÉRIFICATION & ESSAIS</Header>)} name='2verfEssai' equipment={equipment}>
            <Form.Group widths='equal'>
              <Select name='compresseur' formEntry={equipment} options={YesNo()} isRequired label='2.1 Compresseur' />
              <Select
                name='hp' className='second-title' formEntry={equipment} options={[
                  { value: '1/38', text: '1/38' },
                  { value: '1/6', text: '1/6' },
                  { value: '1/3', text: '1/3' },
                  { value: '1/2', text: '1/2' },
                  { value: '3/4', text: '3/4' },
                  { value: '1', text: '1' },
                  { value: '2', text: '2' },
                  { value: '3', text: '3' },
                  { value: '4', text: '4' },
                  { value: '5', text: '5' },
                  { value: 'autres', text: 'Autres' }
                ]} isRequired label='2.1.3 HP'
              />
              <Select name='niveauHuile' className='second-title' formEntry={equipment} options={ConformAdequat()} isFixed label="2.1.6 Niveau d'huile" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='aliementationElectrique' className='second-title' formEntry={equipment} options={ConformAdequat()} isRequired label='2.1.1 Alimentation électrique' />
              <Input name='compresseurAutomatique' className='second-title' formEntry={equipment} isFixed label='2.1.4 Automatique (de - à)' />
              <Select name='dessicant' className='second-title' formEntry={equipment} options={ConformAdequat()} isFixed label='2.1.7 Dessicant' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='regulateurAir' className='second-title' formEntry={equipment} options={ConformAdequat()} isRequired label="2.1.2 Régulateur d'air" />
              <Select name='vidangeDeau' className='second-title' formEntry={equipment} options={YesNoCom()} isFixed label="2.1.5 Vidange d'eau" />
              <Select name='delaiPompage' className='second-title' formEntry={equipment} options={FromTo(1, 60)} isFixed label='2.1.8 Délai de pompage (min.)' />
            </Form.Group>
            <Divider className='dashed' />
            <Form.Group widths='equal'>
              <div className='field' />
              <div className='field' />
              <div className='field'><Header as='h5'>2.5 Avant essai de déclenchement</Header></div>
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='manometre' formEntry={equipment} options={Years()} isRequired label='2.2 Manomètre' />
              <Select name='fonctionnementClapetsRetenue' formEntry={equipment} options={ConformAdequat()} isRequired label='2.3 Fonctionnement clapets retenue' />
              <Select name='pressionAirSysteme' className='second-title' formEntry={equipment} isFixed options={FromTo(0, 60)} label="2.5.1 Pression d'Air du système (psi)" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='manometreEtat' className='second-title' formEntry={equipment} options={ConformAdequat()} isRequired label='2.2.1 État' />
              <div className='field' />
              <Select name='pressionAirDor' className='second-title' formEntry={equipment} isFixed options={FromTo(0, 60)} label="2.5.2 Pression d'air du D.O.R (psi)" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='pressionDernierEtage' className='second-title' formEntry={equipment} isFixed label='2.2.2 Pression au dernier étage (psi)' />
              <Select name='conditionTuyauterieAccessoire' formEntry={equipment} options={ConformAdequat()} isRequired label="2.4 Condition tuyauterie d'accessoire" />
              <Select name='pressionEauAmont' className='second-title' formEntry={equipment} isFixed options={FromTo(0, 175)} label="2.5.3 Pression d'eau en amont (psi)" />
            </Form.Group>
            <Divider className='dashed' />
            <Form.Group widths='equal'>
              <Select name='essaiDeclenchement' formEntry={equipment} options={ConformYes()} label='2.6 Essai de déclenchement' />
              <Select name='essaiRobinetEssai' formEntry={equipment} options={ConformYes()} label="2.7 Essai du robinet d'essai" />
              <Input name='pressionEauAmont2' className='second-title' formEntry={equipment} isFixed label="2.7.4 Pression d'eau en amont (psi)" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='sansEcoulementEau' className='second-title' formEntry={equipment} options={YesNo()} isFixed label="2.6.1 SANS écoulement d'eau" />
              <Select
                name='orifice' className='second-title' formEntry={equipment} options={[
                  { value: '1/2', text: '1/2' },
                  { value: '3/4', text: '3/4' },
                  { value: '1', text: '1' }
                ]} isRequired label='2.7.1 Orifice'
              />
              <Input name='tempsDeclenchement' className='second-title' formEntry={equipment} isFixed label='2.7.5 Temps de déclenchement (sec)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='avecEcoulementEau' className='second-title' formEntry={equipment} options={ConformYes()} isFixed label="2.6.2 AVEC écoulement d'eau" />
              <Input name='pressionDAirDuSystem' className='second-title' formEntry={equipment} isFixed label="2.7.2 Pression d'air du système (psi)" />
              <Input name='tempsDArriveDeauAuPT' className='second-title' formEntry={equipment} isFixed label="2.7.6 Temps d'arrivé d'eau au PT (sec)" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='annee2' className='second-title' formEntry={equipment} options={Years()} isFixed label='2.6.2.1 Année' />
              <Input name='pressionAirDor2' className='second-title' formEntry={equipment} isFixed label="2.7.3 Pression d'air du D.O.R. (psi)" />
              <div className='field' />
            </Form.Group>
            <Divider className='dashed' />
            <Form.Group widths='equal'>
              <Select name='avertisseurHydrauliqueFonctionnel' formEntry={equipment} options={ConformYes()} isFixed label='2.8 Avertisseur hydraulique fonctionnel' />
              <Select name='conditionInterneDuSysteme' formEntry={equipment} options={ConformAdequat()} isFixed label='2.11 Condition interne du système' />
              <Select name='drainageAdequat' formEntry={equipment} options={ConformYes()} isRequired label='2.13 Drainage adéquat' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='tamisNettoye' className='second-title' formEntry={equipment} options={YesNo()} isRequired label='2.8.1 Tamis nettoyé' />
              <Select name='essaiDrainPrincipal' formEntry={equipment} options={ConformYes()} label='2.12 Essai drain principal' />
              <Select name='pointBasVidange' formEntry={equipment} options={ConformYes()} isFixed label='2.14 Points bas vidangés' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='avertisseurElectriqueFonctionnel' formEntry={equipment} options={YesNo()} isFixed label='2.9 Avertisseur électrique fonctionnel' />
              <Select name='residuelle' className='second-title' formEntry={equipment} isFixed options={FromTo(0, 150)} label='2.12.1 Résiduelle (psi)' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='operationRobinetControle' formEntry={equipment} options={ConformYes()} isRequired label='2.10 Opération du robinet de contrôle' />
              <Select name='statique' className='second-title' formEntry={equipment} isFixed options={FromTo(0, 175)} label='2.12.2 Statique (psi)' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Input name='differentiel' className='second-title' formEntry={equipment} isFixed label='2.12.3 Différientiel (%)' />
              <div className='field' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>4. TUYAUTERIE</Header>)} name='4tuyauterie' equipment={equipment}>
            <Form.Group widths='equal'>
              <Select name='tuyauConditionExterne' formEntry={equipment} options={ConformAdequat()} isFixed label='4.1 Condition externe' />
              <Input name='tuyauVerificationInterneRequise' formEntry={equipment} isRequired label='4.5 Vérification interne requise' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='tuyauSupportNombreSuffisant' formEntry={equipment} options={ConformYes()} isFixed label='4.2 Support en nombre suffisant' />
              <Select name='tuyauVerificationQuinquennale' className='second-title' formEntry={equipment} options={YesNo()} isRequired label='4.5.1 Vérification quinquennale' />
              <Select name='tuyauInvestigationObstruction' className='second-title' formEntry={equipment} options={YesNo()} isRequired label="4.5.2 Investigation d'obstruction" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='tuyauSupportBonneCondition' formEntry={equipment} options={ConformYes()} isFixed label='4.3 Support en bonne condition' />
              <Select name='tuyauVerificationQuinquennaleDerniere' className='second-title' formEntry={equipment} options={Years()} isRequired label='4.5.1.1 Dernière (année)' />
              <Select name='tuyauInvestigationObstructionDerniere' className='second-title' formEntry={equipment} options={Years()} isRequired label='4.5.2.1 Dernière (année)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='tuyauSupportSismique' formEntry={equipment} options={ConformYes()} isFixed label='4.4 Support sismique' />
              <Select name='tuyauVerificationQuinquennaleProchaine' className='second-title' formEntry={equipment} options={Years()} isRequired label='4.5.1.2 Prochaine (année)' />
              <Select name='tuyauInvestigationObstructionProchaine' className='second-title' formEntry={equipment} options={Years()} isRequired label='4.5.2.2 Prochaine (année)' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>5. GICLEUR</Header>)} name='5gicleur' equipment={equipment}>
            <Grid>
              <Grid.Row>
                <Grid.Column width='4'>
                  <Select name='gicleurNombreApproximatif' formEntry={equipment} options={FromTo(0, 1000, 10)} isRequired label='5.1 Nombre approximatif' />
                </Grid.Column>
                <Grid.Column width='3' />
                <Grid.Column width='9'>
                  <Select name='gicleurTemperatureDeclenchement' formEntry={equipment} options={ConformAdequat()} isRequired label='5.6 Température de déclenchement' />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width='4'>
                  <Select name='gicleurSupplementairesAccessible' formEntry={equipment} options={ConformYes()} isFixed label='5.2 Supplémentaires accessibles' />
                  <Select name='gicleurClefGicleur' className='second-title' formEntry={equipment} options={ConformYes()} isFixed label='5.3 Clef de gicleur' />
                  <Select name='gicleurConditionGicleur' className='second-title' formEntry={equipment} options={ConformAdequat()} isFixed label='5.4 Condition des gicleurs' />
                  <Select name='gicleurLibreObstruction' className='second-title' formEntry={equipment} options={ConformYes()} isRequired label="5.5 Libre d'obstruction" />
                </Grid.Column>
                <Grid.Column width='3' />
                <Grid.Column width='3'>
                  <Header as='h5' color='red'>PENDANT</Header>
                  <Checkbox name='gicleurPendant135' formEntry={equipment} label='135&deg;F' />
                  <Checkbox name='gicleurPendant155' formEntry={equipment} label='155&deg;F' />
                  <Checkbox name='gicleurPendant174' formEntry={equipment} label='174&deg;F' />
                  <Checkbox name='gicleurPendant200' formEntry={equipment} label='200&deg;F' />
                  <Checkbox name='gicleurPendant286' formEntry={equipment} label='286&deg;F' />
                  <Checkbox name='gicleurPendant360' formEntry={equipment} label='360&deg;F' />
                  <Checkbox name='gicleurPendant500' formEntry={equipment} label='500&deg;F' />
                </Grid.Column>
                <Grid.Column width='3'>
                  <Header as='h5' color='red'>DEBOUT</Header>
                  <Checkbox name='gicleurDebout135' formEntry={equipment} label='135&deg;F' />
                  <Checkbox name='gicleurDebout155' formEntry={equipment} label='155&deg;F' />
                  <Checkbox name='gicleurDebout174' formEntry={equipment} label='174&deg;F' />
                  <Checkbox name='gicleurDebout200' formEntry={equipment} label='200&deg;F' />
                  <Checkbox name='gicleurDebout286' formEntry={equipment} label='286&deg;F' />
                  <Checkbox name='gicleurDebout360' formEntry={equipment} label='360&deg;F' />
                  <Checkbox name='gicleurDebout500' formEntry={equipment} label='500&deg;F' />
                </Grid.Column>
                <Grid.Column width='3'>
                  <Header as='h5' color='red'>MURAL</Header>
                  <Checkbox name='gicleurMural135' formEntry={equipment} label='135&deg;F' />
                  <Checkbox name='gicleurMural155' formEntry={equipment} label='155&deg;F' />
                  <Checkbox name='gicleurMural174' formEntry={equipment} label='174&deg;F' />
                  <Checkbox name='gicleurMural200' formEntry={equipment} label='200&deg;F' />
                  <Checkbox name='gicleurMural286' formEntry={equipment} label='286&deg;F' />
                  <Checkbox name='gicleurMural360' formEntry={equipment} label='360&deg;F' />
                  <Checkbox name='gicleurMural500' formEntry={equipment} label='500&deg;F' />
                </Grid.Column>
              </Grid.Row>
              <Divider className='dashed' />
              <Grid.Row stretched>
                <Grid.Column width='4'>
                  <Header as='h5'>5.7 Type de gicleur</Header>
                  <Select name='gicleurStandardMoins50Ans' formEntry={equipment} options={ConformYes()} isRequired label='5.7.1 Standard moins de 50 ans' />
                  <Select name='gicleurResidentielMoins50Ans' formEntry={equipment} options={ConformYes()} isRequired label='5.7.2 Résidentiel moins de 20 ans' />
                  <Select name='gicleurRepRapideMoins50Ans' formEntry={equipment} options={ConformYes()} isRequired label='5.7.3 Rép. Rapide moins de 20 ans' />
                  <Select name='gicleurSecMoins10Ans' formEntry={equipment} options={ConformYes()} isRequired label='5.7.4 Sec moins de 10 ans' />
                  <Select name='gicleurTHMoins5Ans' formEntry={equipment} options={YesNo()} isRequired label='5.7.5 T.H. temp. moins de 5 ans' />
                </Grid.Column>
                <Grid.Column width='3' />
                <Grid.Column width='9' verticalAlign='bottom'>
                  <Select name='gicleurEchantillonageGicleurRectification' formEntry={equipment} options={YesNo()} isFixed label='5.8 Échantillonage de gicleur pour recertification' />
                  <Input name='gicleurSection' className='second-title' formEntry={equipment} isFixed label='5.8.1 Section' />
                  <Input name='gicleurQuantite' className='second-title' formEntry={equipment} isFixed label='5.8.2 Quantité (1% ou min. 4) (Qté)' />
                  <Select name='gicleurSectionsBatimentProtege' formEntry={equipment} options={YesNo()} isRequired label='5.9 Toutes les sections du bâtiments sont protégées adéquatement' />
                  <Select name='gicleurDegagementMinimal' formEntry={equipment} options={YesNo()} isRequired label='5.10 Dégagement minimal et maximal des gicleurs sont respectés' />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Section title={(<Header as='h2'>6. VÉRIFICATION DU RACCORD POMPIER (R.P.)</Header>)} name='6verfRaccordPompier' equipment={equipment}>
            <Duplicate
              name='raccordPompierList' btnLabel='Raccord' equipment={equipment} renderGroup={(index) => {
                return (
                  <Fragment key={`rpl${index}`}>
                    <Header as='h5'>Raccord #{index + 1}</Header>
                    <Form.Group widths='equal'>
                      <Input name={`raccordPompierLocalisation${index || ''}`} formEntry={equipment} isRequired label='6.1 Localisation' />
                      <Select name={`raccordPompierZoneDesservi${index || ''}`} options={ConformAdequat()} formEntry={equipment} isRequired label='6.6 Identification de la zone desservi' />
                      <Select name={`raccordPompierJointEtancheite${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label="6.10 Joint d'étanchéité" />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Select name={`raccordPompierNombrePrise${index || ''}`} options={FromTo(1, 2)} formEntry={equipment} isRequired label='6.2 Nombre de prise' />
                      <Select name={`raccordPompierAccessibilite${index || ''}`} options={ConformAdequat()} formEntry={equipment} isRequired label='6.7 Accessibilité' />
                      <Select name={`raccordPompierPlaquetteIdentification${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label="6.11 Plaquette d'identification" />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Select name={`raccordPompierTypeRP${index || ''}`} options={[{ value: 'encastre', text: 'Encastré' }, { value: 'surface', text: 'Surface' }, { value: 'storz', text: 'Storz' }, { value: 'vertical', text: 'Vertical' }]} formEntry={equipment} isRequired label='6.3 Type de R.P.' />
                      <Select name={`raccordPompierRotationSortieAmont${index || ''}`} options={ConformAdequat()} formEntry={equipment} isFixed label='6.8 Rotations des sorties en amont' />
                      <Select name={`raccordPompierClapetRetenueFonctionnel${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label='6.12 Clapet de retenue fonctionnel' />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Select name={`raccordPompierDistanceRPaBF${index || ''}`} options={FromTo(1, 100)} formEntry={equipment} isRequired label='6.4 Distance R.P. à une B.F. (m.)' />
                      <Select name={`raccordPompierTypeRotation${index || ''}`} className='second-title' options={[{ value: 'qst', text: 'QST' }, { value: 'storz', text: 'storz' }, { value: 'Sherbrooke', text: 'Sherbrooke' }]} formEntry={equipment} isRequired label='6.8.1 Type de rotations' />
                      <Select name={`raccordPompierBilleEgoutementPresente${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label="6.13 Bille d'égoutement présente" />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Select name={`raccordPompierVisibilite${index || ''}`} options={ConformAdequat()} formEntry={equipment} isFixed label='6.5 Visibilité' />
                      <Select name={`raccordPompierBouchonOuCapuchonPresent${index || ''}`} options={ConformYes()} formEntry={equipment} isFixed label='6.9 Bouchons ou capuchons présent' />
                      <Select name={`raccordPompierPivotFonctionnel${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label='6.14 Le pivot est fonctionnel' />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <div className='field' />
                      <div className='field' />
                      <Select name={`raccordPompierConditionInterne${index || ''}`} options={ConformAdequat()} formEntry={equipment} isRequired label='6.15 Condition interne' />
                    </Form.Group>
                  </Fragment>
                )
              }}
            />
          </Section>
          <Section
            title={(<Header as='h2'>9. BASSIN - RÉSERVOIR</Header>)}
            secondaryField={(<Select name='bassinReservoirType' formEntry={equipment} options={[{ value: 'bassin', text: 'Bassin' }, { value: 'reservoir', text: 'Réservoir' }]} />)}
            name='9bassinReservoir' equipment={equipment}
          >
            <Header as='h5'>9.1 Inspection / maintenance</Header>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinNiveauDeau' options={ConformAdequat()} formEntry={equipment} isFixed label="9.1.1 Niveau d'eau" />
              <Select name='reservoirBassinConditionExterne' options={ConformAdequat()} formEntry={equipment} isFixed label='9.1.6 Condition externe' />
              <Select name='reservoirBassinClapetRetenue' options={ConformAdequat()} formEntry={equipment} isRequired label='9.1.11 Clapet de retenue' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinTemperatureEau' options={ConformAdequat()} formEntry={equipment} isFixed label="9.1.2 Température de l'eau" />
              <Select name='reservoirBassinSupportStructure' options={ConformAdequat()} formEntry={equipment} isRequired label='9.1.7 Support et structure' />
              <Select name='reservoirBassinTamisFiltresOrifices' options={ConformAdequat()} formEntry={equipment} isRequired label='9.1.12 Tamis, filtres et orifices' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinSystemeChauffage' options={ConformAdequat()} formEntry={equipment} isFixed label='9.1.3 Système de chauffage' />
              <Select name='reservoirBassinPasserelleEchelle' options={ConformAdequat()} formEntry={equipment} isRequired label='9.1.8 Passerelles et échelles' />
              <Select name='reservoirBassinLocalSoupape' options={ConformAdequat()} formEntry={equipment} isRequired label='9.1.13 Local des soupapes' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinValveControle' options={ConformAdequat()} formEntry={equipment} isFixed label='9.1.4 Valve de contrôle' />
              <Select name='reservoirBassinJointsExpansion' options={ConformAdequat()} formEntry={equipment} isRequired label="9.1.9 Joints d'expansion" />
              <Select name='reservoirBassinTuyauterieTropPlein' options={ConformAdequat()} formEntry={equipment} isRequired label='9.1.14 Tuyauterie de trop plein' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinPressionAir' options={FromTo(0, 200)} formEntry={equipment} isFixed label="9.1.5 Pression d'air (psi)" />
              <Select name='reservoirBassinIntérieur' options={ConformAdequat()} formEntry={equipment} isRequired label='9.1.10 Intérieur' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Select name='reservoirBassinIntérieurInterne' className='second-title' options={Years()} formEntry={equipment} isRequired label='9.1.10.1 Dernière vérification interne' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Select name='reservoirBassinIntérieurExterne' className='second-title' options={Years()} formEntry={equipment} isRequired label='9.1.10.2 Dernière vérification externe' />
              <div className='field' />
            </Form.Group>
            <Divider className='dashed' />
            <Header as='h5'>9.2 Test</Header>
            <Form.Group widths='equal'>
              <Input name='reservoirBassinAlarmesHauteBasseTemperature' formEntry={equipment} isFixed label='9.2.1" Alarmes de haute/basse température (&deg;C)' />
              <Select name='reservoirBassinAlarmeBasNiveau' options={ConformAdequat()} formEntry={equipment} isFixed label='9.2.4 Alarme de bas niveau' />
              <Select name='reservoirBassinInterrupteurValveAutomatique' options={ConformYes()} formEntry={equipment} isFixed label='9.2.7 Interrupteur de la valve automatique' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinInterrupteurSystemeChauffage' options={ConformAdequat()} formEntry={equipment} isFixed label='9.2.2 Interrupteur du système de chauffage' />
              <Select name='reservoirBassinIndicateurNiveau' options={ConformAdequat()} formEntry={equipment} isFixed label='9.2.5 Indicateur de niveau' />
              <Select name='reservoirBassinOperationValveAutomatique' options={ConformYes()} formEntry={equipment} isFixed label='9.2.8 Opération de la valve automatique' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinAlarmeHautNiveau' options={ConformAdequat()} formEntry={equipment} isFixed label='9.2.3 Alarme de haut niveau' />
              <Select name='reservoirBassinManometre' options={Years()} formEntry={equipment} isRequired label='9.2.6 Manomètre' />
              <Select name='reservoirBassinOperationValveRemplissage' options={ConformYes()} formEntry={equipment} isFixed label='9.2.9 Opération de la valve de remplissage (manuel)' />
            </Form.Group>
          </Section>
          <Section
            title={(<Header as='h2'>10. MOUSSE</Header>)}
            secondaryField={(<Input name='mousseLocalisation' formEntry={equipment} label='Localisation' />)}
            name='10mousse' equipment={equipment}
          >
            <Header as='h5'>10.2 Réservoir</Header>
            <Form.Group widths='equal'>
              <Input name='mousseMarque' formEntry={equipment} isRequired label='10.2.1 Marque' />
              <Select name='mousseTamisFiltresOrifices' options={ConformAdequat()} formEntry={equipment} isRequired label='10.2.7 Tamis, filtres et orifices' />
              <Select name='mousseValveSolenoide' options={ConformAdequat()} formEntry={equipment} isRequired label='10.2.13 Valve solénoïde' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='mousseModele' formEntry={equipment} isRequired label='10.2.2 Modèle' />
              <Select name='mousseEvent' options={ConformAdequat()} formEntry={equipment} isFixed label='10.2.8 Évent' />
              <Select name='mousseManometre' options={Years()} formEntry={equipment} isRequired label='10.2.14 Manomètre' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='mousseAnnee' options={Years()} formEntry={equipment} isRequired label='10.2.3 Année' />
              <Select name='mousseNiveauMousee' options={ConformAdequat()} formEntry={equipment} isFixed label='10.2.9 Niveau de la mousse' />
              <Select name='mousseDrainageAdequat' options={ConformYes()} formEntry={equipment} isRequired label='10.2.15 Drainage adéquat' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='mousseCapacite' formEntry={equipment} isRequired label='10.2.4 Capacité' />
              <Select name='mousseRobinetDechargeMousse' options={ConformAdequat()} formEntry={equipment} isFixed label='10.2.10 Robinet de décharge de la mousse' />
              <Input name='mousseType' formEntry={equipment} isRequired label='10.2.16 Type de réservoir' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='moussePompeInjection' options={ConformAdequat()} formEntry={equipment} isRequired label='10.2.5 Pompe à injection' />
              <Input name='mousseTypeValve' className='second-title' formEntry={equipment} isFixed label='10.2.10.1 Type de valve' />
              <Select name='mousseVerticaleHorizontale' className='second-title' options={[{ value: 'verticale', text: 'Verticale' }, { value: 'horizontale', text: 'Horizontale' }]} formEntry={equipment} isRequired label='10.2.16.1 Verticale ou horizontale' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='mousseSoupapeSurete' className='second-title' options={ConformAdequat()} formEntry={equipment} isRequired label='10.2.5.1 Soupape de sûreté' />
              <Input name='mousseActivationValve' className='second-title' formEntry={equipment} isRequired label='10.2.10.2 Activation de la valve' />
              <Select name='moussePressuriseNonPress' className='second-title' options={[{ value: 'pressurise', text: 'Pressurisé' }, { value: 'nonpressurise', text: 'Non-pressurisé' }]} formEntry={equipment} isRequired label='10.2.16.2 Pressurisé ou non-press.' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='mousseSoupapeSureteReservoir' options={ConformAdequat()} formEntry={equipment} isRequired label='10.2.6 Soupape de sûreté du réservoir' />
              <Select name='mousseRobinetIsolationMousse' options={ConformAdequat()} formEntry={equipment} isRequired label="10.2.11 Robinet d'isolation de la mousse" />
              <Input name='moussePression' className='second-title' formEntry={equipment} isRequired label='10.2.16.3 Pression' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Select name='mousseTuyauterieAlimentationMousse' options={ConformAdequat()} formEntry={equipment} isFixed label="10.2.12 Tuyauterie d'alimentation de la mousse" />
              <Input name='mousseRobinetControleAlimentationEauReservoir' formEntry={equipment} isRequired label="10.2.17 Robinet de contrôle d'alimentation en eau du réservoir" />
            </Form.Group>
            <Divider className='dashed' />
            <Header as='h5'>10.3 Proportionneur</Header>
            <Form.Group widths='equal'>
              <Input name='mousseProportionneurMarque' formEntry={equipment} isRequired label='10.3.1 Marque' />
              <Input name='mousseProportionneurModele' formEntry={equipment} isRequired label='10.3.2 Modèle' />
              <Input name='mousseProportionneurDiametre' formEntry={equipment} isRequired label='10.3.3 Diamètre (x/y)' />
            </Form.Group>
            <Divider className='dashed' />
            <Header as='h5'>10.4 Échantillonnage</Header>
            <Form.Group widths='equal'>
              <Select name='mousseEchantillonnageTypeMousse' formEntry={equipment} options={[{ value: 'AFFF', text: 'AFFF' }, { value: 'autre', text: 'autres' }]} isRequired label='10.4.1 Type de mousse' />
              <Input name='mousseEchantillonnageConcentré' formEntry={equipment} isRequired label='10.4.2 Concentré' />
              <Input name='mousseEchantillonnageSortieProportionneur' formEntry={equipment} isRequired label='10.4.3 À la sortie du proportionneur' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Input name='mousseEchantillonnageAnneeMois' className='second-title' formEntry={equipment} isRequired label='10.4.2.1 Année/mois' />
              <Input name='mousseEchantillonnageAnneeMois2' className='second-title' formEntry={equipment} isRequired label='10.4.3.1 Année/mois' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Input name='mousseEchantillonnageLieuxPriseEchantillion' className='second-title' formEntry={equipment} isRequired label='10.4.2.2 Lieux de la prise d’échantilion' />
              <div className='field' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>11. VALVE RÉGULATRICE DE PRESSION</Header>)} name='11valveRegPression' equipment={equipment}>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionValveMaitresse' formEntry={equipment} options={YesNo()} isRequired label='11.1 Valve maîtresse' />
              <Select name='valveRegulatricePressionSoupapeSurete' formEntry={equipment} options={ConformAdequat()} isRequired label='11.1.10 Soupape de sûreté' />
              <Select name='valveRegulatricePressionAccouplement' formEntry={equipment} options={ConformAdequat()} isFixed label='11.5.2 Accouplement' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='valveRegulatricePressionMarque' formEntry={equipment} isRequired label='11.1.1 Marque' />
              <Select name='valveRegulatricePressionManometre' formEntry={equipment} options={Years()} isRequired label='11.1.11 Manomètre' />
              <Input name='valveRegulatricePressionFuite' formEntry={equipment} isFixed label='11.5.3 Fuite' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='valveRegulatricePressionModele' formEntry={equipment} isRequired label='11.1.2 Modèle' />
              <Select name='valveRegulatricePressionEssaiPartielEffectue' formEntry={equipment} options={ConformYes()} isFixed label='11.1.12 Essai partiel effectué (voir tableau)' />
              <Select name='valveRegulatricePressionReducteurBouchon' formEntry={equipment} options={ConformAdequat()} isFixed label='11.5.4 Réducteur et bouchon' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='valveRegulatricePressionNoSerie' formEntry={equipment} isRequired label='11.1.3 No de série' />
              <Select name='valveRegulatricePressionEssaiEcoulement' formEntry={equipment} options={ConformYes()} isFixed label='11.1.13 Essai d’écoulement (voir tableau)' />
              <Select name='valveRegulatricePressionSoupapeSurete' formEntry={equipment} options={ConformAdequat()} isRequired label='11.6 Soupape de sûreté' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionAnnee' formEntry={equipment} options={Years()} isRequired label='11.1.4 Année' />
              <Select
                name='valveRegulatricePressionValveSecondaire' formEntry={equipment} options={[
                  { value: 'gicleur', text: 'Système de gicleur' },
                  { value: 'robinet', text: 'Robinets armés' },
                  { value: 'boyeaux', text: 'Boyaux incendie' }
                ]} isRequired label='11.2 Valve secondaire'
              />
              <Select name='valveRegulatricePressionEssaiPartielEffectue2' formEntry={equipment} options={ConformYes()} isFixed label='11.7 Essai partiel effectué (voir tableau)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionDiametre' formEntry={equipment} options={FromTo(1, 12)} isRequired label='11.1.5 Diamètre' />
              <Select name='valveRegulatricePressionPressionEcharge' formEntry={equipment} isFixed options={FromTo(0, 175)} label='11.3 Pression décharge' />
              <Select name='valveRegulatricePressionEssaiDecoulement2' formEntry={equipment} options={ConformYes()} isFixed label="11.8 Essai d'écoulement (voir tableau)" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionPressionAjustementIndiquee' formEntry={equipment} isRequired options={FromTo(0, 175)} label="11.1.6 Pression d'ajustement indiquée" />
              <Select name='valveRegulatricePressionPressionSuccion' formEntry={equipment} isFixed options={FromTo(0, 300)} label='11.4 Pression succion' />
              <Select name='valveRegulatricePressionEssaiDerniere' formEntry={equipment} options={Years()} isRequired label='11.8.1 Dernière' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionPressionDecharge2' formEntry={equipment} isFixed options={FromTo(0, 300)} label='11.1.7 Pression décharge' />
              <Select name='valveRegulatricePressionConditionValve' formEntry={equipment} options={ConformAdequat()} label='11.5 Condition de la valve' />
              <Input name='valveRegulatricePressionProchaine' formEntry={equipment} isRequired label='11.8.2 Prochaine' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionPressionSuccion2' formEntry={equipment} isFixed options={FromTo(0, 300)} label='11.1.8 Pression succion' />
              <Select name='valveRegulatricePressionConditionOperation' formEntry={equipment} options={ConformAdequat()} isFixed label="11.5.1 Condition d'opération" />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionConditionValve2' formEntry={equipment} options={ConformAdequat()} isFixed label='11.1.9 Condition de la valve' />
              <Input name='valveRegulatricePressionEtat' formEntry={equipment} isFixed label='11.5.1.1 État' />
              <div className='field' />
            </Form.Group>
          </Section>
        </Form>
      </>
    )
  }
}

RIGSAR000.fieldsRequired = [
  {
    section: '1naCheckbox',
    fields: [
      'localisation',
      'overRapidMarque',
      'numSysteme',
      'overRapidModele',
      'zoneProtege',
      'overRapidNumSerie',
      'marque',
      'dispositifAntiNoyade',
      'modele',
      'interrupteurPressionMarque',
      'numSerie',
      'typeInterrupteurAlarm',
      'interrupteurPressionModele',
      'annee',
      'interrupteurPression2',
      'nbPointBas',
      'diametre',
      'empalcementRobinetEssai'
    ]
  }, {
    section: '2verfEssai',
    fields: [
      'compresseur',
      'hp',
      'aliementationElectrique',
      'regulateurAir',
      'manometre',
      'fonctionnementClapetsRetenue',
      'manometreEtat',
      'conditionTuyauterieAccessoire',
      'orifice',
      'drainageAdequat',
      'tamisNettoye',
      'operationRobinetControle'
    ]
  }, {
    section: '4tuyauterie',
    fields: [
      'tuyauVerificationInterneRequise',
      'tuyauVerificationQuinquennale',
      'tuyauInvestigationObstruction',
      'tuyauVerificationQuinquennaleDerniere',
      'tuyauInvestigationObstructionDerniere',
      'tuyauVerificationQuinquennaleProchaine',
      'tuyauInvestigationObstructionProchaine'
    ]
  }, {
    section: '5gicleur',
    fields: [
      'gicleurNombreApproximatif',
      'gicleurTemperatureDeclenchement',
      'gicleurLibreObstruction',
      'gicleurStandardMoins50Ans',
      'gicleurResidentielMoins50Ans',
      'gicleurRepRapideMoins50Ans',
      'gicleurSecMoins10Ans',
      'gicleurTHMoins5Ans',
      'gicleurSectionsBatimentProtege',
      'gicleurDegagementMinimal'
    ]
  }, {
    section: '9bassinReservoir',
    fields: [
      'reservoirBassinClapetRetenue',
      'reservoirBassinSupportStructure',
      'reservoirBassinTamisFiltresOrifices',
      'reservoirBassinPasserelleEchelle',
      'reservoirBassinLocalSoupape',
      'reservoirBassinJointsExpansion',
      'reservoirBassinTuyauterieTropPlein',
      'reservoirBassinIntérieur',
      'reservoirBassinIntérieurInterne',
      'reservoirBassinIntérieurExterne',
      'reservoirBassinManometre'
    ]
  }, {
    section: '10mousse',
    fields: [
      'mousseMarque',
      'mousseTamisFiltresOrifices',
      'mousseValveSolenoide',
      'mousseModele',
      'mousseManometre',
      'mousseAnnee',
      'mousseDrainageAdequat',
      'mousseCapacite',
      'mousseType',
      'moussePompeInjection',
      'mousseSoupapeSurete',
      'mousseActivationValve',
      'mousseSoupapeSureteReservoir',
      'mousseRobinetIsolationMousse',
      'moussePression',
      'mousseRobinetControleAlimentationEauReservoir',
      'mousseProportionneurMarque',
      'mousseProportionneurModele',
      'mousseProportionneurDiametre',
      'mousseEchantillonnageTypeMousse',
      'mousseEchantillonnageConcentré',
      'mousseEchantillonnageSortieProportionneur',
      'mousseEchantillonnageAnneeMois',
      'mousseEchantillonnageAnneeMois2',
      'mousseEchantillonnageLieuxPriseEchantillion'
    ]
  }, {
    section: '11valveRegPression',
    fields: [
      'valveRegulatricePressionValveMaitresse',
      'valveRegulatricePressionSoupapeSurete',
      'valveRegulatricePressionMarque',
      'valveRegulatricePressionManometre',
      'valveRegulatricePressionModele',
      'valveRegulatricePressionNoSerie',
      'valveRegulatricePressionSoupapeSurete',
      'valveRegulatricePressionAnnee',
      'valveRegulatricePressionValveSecondaire',
      'valveRegulatricePressionDiametre',
      'valveRegulatricePressionPressionAjustementIndiquee',
      'valveRegulatricePressionEssaiDerniere',
      'valveRegulatricePressionProchaine'
    ]
  }
]
RIGSAR000.dynamicFieldsRequired = [{
  section: '6verfRaccordPompier',
  name: 'raccordPompierList',
  fields: [
    'raccordPompierLocalisation',
    'raccordPompierZoneDesservi',
    'raccordPompierJointEtancheite',
    'raccordPompierNombrePrise',
    'raccordPompierAccessibilite',
    'raccordPompierPlaquetteIdentification',
    'raccordPompierTypeRP',
    'raccordPompierRotationSortieAmont',
    'raccordPompierClapetRetenueFonctionnel',
    'raccordPompierDistanceRPaBF',
    'raccordPompierTypeRotation',
    'raccordPompierBilleEgoutementPresente',
    'raccordPompierVisibilite',
    'raccordPompierBouchonOuCapuchonPresent',
    'raccordPompierPivotFonctionnel',
    'raccordPompierConditionInterne'
  ]
}

]
export default RIGSAR000
